import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { TEAM_DATA_LOCKER_DEFAULT_COLUMNS } from '@/consts/dataLocker/team';

const teamDataDefaultColumnsAtom = atom(async () => [...TEAM_DATA_LOCKER_DEFAULT_COLUMNS]);
export const unwrappedTeamDataDefaultColumnsAtom = unwrap(teamDataDefaultColumnsAtom, prev => prev || []);
